import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import "./WhatsAppChat.scss";

// WhatsApp number (country code without + or spaces)
const WA_NUMBER = "94768309969";
const WA_MESSAGE = encodeURIComponent(
  "Hi Abilasha! I visited your portfolio and I'd love to connect. 👋"
);
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

const WhatsAppChat = () => {
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleOpen = () => {
    window.open(WA_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="wa-wrapper">
      {/* Chat bubble popup */}
      {expanded && !dismissed && (
        <div className="wa-bubble" role="dialog" aria-label="WhatsApp chat">
          <button
            className="wa-bubble__close"
            onClick={() => { setExpanded(false); setDismissed(true); }}
            aria-label="Close"
          >
            <MdClose />
          </button>
          <div className="wa-bubble__avatar">
            <FaWhatsapp className="wa-bubble__avatar-icon" />
          </div>
          <div className="wa-bubble__body">
            <p className="wa-bubble__name">Abilasha Wickramarathna</p>
            <p className="wa-bubble__status">
              <span className="wa-bubble__dot" /> Typically replies instantly
            </p>
            <p className="wa-bubble__msg">
              Hi there! 👋 Need help or want to collaborate? Let's chat on WhatsApp!
            </p>
          </div>
          <button className="wa-bubble__cta" onClick={handleOpen}>
            <FaWhatsapp className="wa-bubble__cta-icon" />
            Start Chat
          </button>
        </div>
      )}

      {/* FAB trigger button */}
      <button
        className={`wa-fab ${expanded ? "wa-fab--active" : ""}`}
        onClick={() => setExpanded((prev) => !prev)}
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse rings */}
        <span className="wa-fab__ring wa-fab__ring--1" />
        <span className="wa-fab__ring wa-fab__ring--2" />

        <FaWhatsapp className="wa-fab__icon" />

        {/* Notification dot */}
        {!expanded && (
          <span className="wa-fab__notif" aria-hidden="true">1</span>
        )}
      </button>

      {/* Label tooltip */}
      {!expanded && (
        <span className="wa-label">Chat with me</span>
      )}
    </div>
  );
};

export default WhatsAppChat;
